import { render, staticRenderFns } from "./ChequePage.vue?vue&type=template&id=b5072b72&scoped=true&"
import script from "./ChequePage.vue?vue&type=script&lang=js&"
export * from "./ChequePage.vue?vue&type=script&lang=js&"
import style0 from "./ChequePage.vue?vue&type=style&index=0&id=b5072b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5072b72",
  null
  
)

export default component.exports